/*eslint-disable */
import Vue from 'vue'
var $ = window.jQuery = require('jquery');
import toast from '@/services/toast';
import videoSocketRef from "@/videoNotificationSocket";
import moment from 'moment';
import {
  bus
} from '@/main';
export default {
  name: 'msg-delete-popup',
  components: {},
  props: ['deleteMessageDataOBJ'],
  data () {
    return {
      submitted:false,
      removeMsgId:'',
      checkMsgDeleteEveryOneState:false,
      selfUserId:''
    }
  },
  computed: {

  },
  mounted () {
    this.removeMsgId = this.deleteMessageDataOBJ.id
    if(localStorage.getItem('LoginedUserID')){
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    if(this.deleteMessageDataOBJ.createdBy == this.selfUserId){
      this.enabledDeleteMsorEveryOneMethod(this.deleteMessageDataOBJ.time)
    }
  },
  methods: {
    enabledDeleteMsorEveryOneMethod(startTime){
      var currentLocalDate = moment().format('MMMM Do YYYY');
      var startDateCheck = moment(startTime).format('MMMM Do YYYY')
      var currentLocalHours = moment().format('HH')
      var currentLocalTime = moment().format('mm:ss')
      var startTimeHours = moment(startTime).format('HH')
      var startTimeCheck = moment(startTime).format('mm:ss')
      if(startDateCheck === currentLocalDate){
          var totalMinutesOfStartMeeting  = startTimeHours*parseInt(60) + parseInt(startTimeCheck);
          var totalMinutesOfCurrent  = currentLocalHours*parseInt(60) + parseInt(currentLocalTime);
          if(totalMinutesOfCurrent > (totalMinutesOfStartMeeting - parseInt(1))){
            var validTime = totalMinutesOfCurrent - totalMinutesOfStartMeeting - parseInt(1)
            if(parseInt(9) > validTime){
              this.checkMsgDeleteEveryOneState = true
              return;
            }else{
              this.checkMsgDeleteEveryOneState = false
              return;
            }
          }else{
              this.checkMsgDeleteEveryOneState = false
            return;
          }
      }else{
              this.checkMsgDeleteEveryOneState = false
        return;
      }
    },
    confirmDeleteMessageFormChatFun(delete_for_everyone){
      var queryData = 'no';
      this.submitted =  true
      if(delete_for_everyone == true){
        queryData = 'yes'
      }
      this.$store.dispatch('deleteMsgOfChatInWorkspaceAction',{data:{id:this.removeMsgId,query:queryData}}).then((res) => {
        if(delete_for_everyone == true){
          let dateTimeAdd = [moment(this.deleteMessageDataOBJ.time).format('h:mm a')];
          $('#chatMessageId' + this.removeMsgId + ' ' + '.dropdown').remove()        
          $('#chatMessageId' + this.removeMsgId + ' ' + 'label').remove()         
          $('#chatMessageId' + this.removeMsgId + ' ' + '.msg_in_file').remove()        
          $('#chatMessageId' + this.removeMsgId + ' ' + '.chat_in_msg_box_wrp').addClass('delete_msg_show_box')           
          $('#chatMessageId' + this.removeMsgId + ' ' + '.chat_in_msg_box_wrp').html(`<span class='chat_msg_content_show'><i aria-hidden='true' class='fa fa-ban'></i> This message was deleted</span><span class='msg_time_wrp'><time class='msg_time'>${dateTimeAdd}</time></span>`)
          if(videoSocketRef.isOpen()){
            videoSocketRef.emit({
              type: "messageDeleteForChatOfAll",
              selfUserID:this.selfUserId,
              targetForChatMsgId:this.removeMsgId,
              targetForChatMsgTime:this.deleteMessageDataOBJ.time
            });
          }
        }else{
          $('#chatMessageId' + this.removeMsgId).remove()
        }
        toast.success(res.data.msg);
        this.deleteMessagePopupDisabledFun()
        this.submitted =  false
      }).catch((err)=>{
        this.submitted =  false
        toast.error(err.data.msg);
      })
    },
    deleteMessagePopupDisabledFun(){
      this.checkMsgDeleteEveryOneState = false
      $('body').removeClass('body_right_scroll_remove')
      bus.$emit('deleteMsgPopupStateBus', false);
    }
  }
}